// extracted by mini-css-extract-plugin
export default {"wrapper":"Ye2hsFUYZcA0PSyGjcQ8"};